module.exports = __webpack_public_path__ + "img/canyon_natural_ba_detail_rsh10(1).bbd4d69f.jpg";